import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["title", "children"];
import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CallShow(props) {
  var _ref = props || {},
    {
      title = '提示框',
      children
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  var dv = document.createElement('div');
  dv.id = 'uiw-modal-call-show-element';
  document.body.appendChild(dv);
  ReactDOM.render( /*#__PURE__*/_jsx(Modal, _extends({}, other, {
    title: title,
    isOpen: true,
    onClosed: () => {
      dv.remove();
    },
    children: children
  })), dv);
}